
export const DynamicLink= {
    RP_WL_API:"https://waitlist-api.realprotocol.co"   //http://10.10.4.229:3009/,https://real-protocol-wl-api-dev.sandbox158.run   
   
}
